// barakali-preview — b04 "Barakali" birthday card.
//
// Soft cream paper with a sage-teal accent. A laurel half-wreath crowns the
// portrait medallion; the celebrant's name renders in Cormorant Garamond
// with a "TUG'ILGAN KUN" eyebrow and a venue line below.
import { Photo, type LayoutCtx } from "./_shared";

export function BarakaliPreviewLayout({ names, date, venue, accent, ink, bg, font, photo }: LayoutCtx) {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: `linear-gradient(180deg, ${bg} 0%, ${accent}1A 100%)`,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          position: "relative",
          background: bg,
          color: ink,
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.4em",
            color: accent,
            marginBottom: "5%",
          }}
        >
          TUG'ILGAN KUN
        </div>

        {/* Laurel wreath portrait */}
        <div style={{ width: "62%", aspectRatio: "1 / 1", marginBottom: "5%", position: "relative" }}>
          <div
            style={{
              position: "absolute",
              inset: "12%",
              borderRadius: "50%",
              overflow: "hidden",
              boxShadow: `0 0 0 1px ${accent}66`,
            }}
          >
            <Photo
              src={photo}
              style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
              fallback={
                <div
                  style={{
                    position: "absolute",
                    inset: 0,
                    background: `radial-gradient(circle at 50% 45%, ${accent}33, ${bg})`,
                  }}
                />
              }
            />
          </div>
          {/* Laurel branches */}
          <svg viewBox="0 0 100 100" style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}>
            <g fill={accent} opacity="0.85">
              {/* Left laurel */}
              <g transform="translate(8 50)">
                <path d="M0 0 Q 18 -22 42 -36"
                      fill="none" stroke={accent} strokeWidth="0.6" />
                {Array.from({ length: 7 }).map((_, i) => {
                  const t = i / 6;
                  const x = t * 42;
                  const y = -22 * t * (1 - t * 0.3) - 14 * t;
                  return (
                    <ellipse key={i} cx={x} cy={y} rx="3.2" ry="1.4"
                             transform={`rotate(${-30 - t * 30} ${x} ${y})`} />
                  );
                })}
              </g>
              {/* Right laurel */}
              <g transform="translate(92 50) scale(-1 1)">
                <path d="M0 0 Q 18 -22 42 -36"
                      fill="none" stroke={accent} strokeWidth="0.6" />
                {Array.from({ length: 7 }).map((_, i) => {
                  const t = i / 6;
                  const x = t * 42;
                  const y = -22 * t * (1 - t * 0.3) - 14 * t;
                  return (
                    <ellipse key={i} cx={x} cy={y} rx="3.2" ry="1.4"
                             transform={`rotate(${-30 - t * 30} ${x} ${y})`} />
                  );
                })}
              </g>
            </g>
          </svg>
        </div>

        <div style={{ fontFamily: font, fontSize: 32, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.32em",
            color: accent,
            marginTop: "4%",
          }}
        >
          TUG'ILGAN KUN · {date}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.28em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
